import AddAppointment from "components/appointment/AddAppointment";
import { ArrowLeft } from "lucide-react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "reactstrap";
import { appointmentsSelector } from "slices/appointmentSlice";
import { closeAppointmentPopup, setAddAppointmentPopup } from "slices/appointmentSlice";
import { fetchDashboardAnalytics } from "slices/dashboardSlice";
import { fetchDashboardAppointments } from "slices/dashboardSlice";
import { interpreterProfileSelector } from "slices/interpreter/profileSlice";
import { cdn } from 'constants/common';
import IncomingCalls from "components/IncomingCallPopup";
let userSlice;
function Header(props) {
  const [color] = React.useState("transparent");
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);

  const refDropdown = React.useRef(null);

  useEffect(() => {
    userSlice = require("../../slices/userSlice");
  }, []);

  const { interpreterProfile } = useSelector(interpreterProfileSelector);
  const displayUser = interpreterProfile?.user;
  const isJoinRoomCall = location.pathname.includes("join-room-call");
  const videoCallAppid = useSelector((state) => state.interpreterIframe.appid);

  const handleVideoCallBack = () => {
    const match = location.pathname.match(/\/view\/(\d+)\/join-room-call/);
    const id = match?.[1];
    navigate(id ? `/interpreter/appointments/view/${id}` : '/interpreter/dashboard');
  };
  
  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refDropdown.current && !refDropdown.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
  }, [location]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = () => {
    dispatch(userSlice.logout());
    navigate("/login", { replace: true });
  };

  return (
    <>
    
        <IncomingCalls />
      <Navbar
        expand="lg"
        className={
          location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute border-0 fixed-top"
            : "navbar-absolute border-0 fixed-top " +
              (color === "transparent" ? "navbar-transparent " : "")
        }
      >
        <div className="header">
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <button className="toggle_sidebar" onClick={props.toggleSidebar}>
              <img src="/images/ham.png" alt="" />
            </button>
            {isJoinRoomCall && (
              <>
                <button
                  onClick={handleVideoCallBack}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: "6px 8px", display: "flex", alignItems: "center" }}
                >
                  <ArrowLeft size={22} />
                </button>
                {videoCallAppid && (
                  <span style={{ fontSize: 14, fontWeight: 600, color: "#333" }}>
                    Appointment #{videoCallAppid}
                  </span>
                )}
              </>
            )}
          </div>

          <div className="row_user_side">
            <div ref={refDropdown} className="d-flex align-items-center gap-2 position-relative">
              <button className="user_image" onClick={toggleDropdown}>
                {/* <img src="/images/default-person.png" alt="s" /> */}
                  {displayUser?.image ? (
                    <img src={cdn + displayUser.image} alt={displayUser.name} />
                  ) : (
                    <img src="/images/default-person.png" alt="Default profile" />
                  )}
                <span></span>
              </button>

              <button
                className={`drop_icon ${dropdownOpen ? "active" : ""}`}
                onClick={toggleDropdown}
              >
                <img src="/images/drop.png" alt="" />
              </button>

              <div
                className={`drop_more_selector ${
                  dropdownOpen ? "active" : ""
                }`}
              >
                <ul>
                  <li>
                    <Link to="/interpreter/profile">Profile</Link>
                  </li>
                  <li>
                    <Link to="/interpreter/change-password">Change Password</Link>
                  </li>
                  <li>
                    <Link href="#!">Help</Link>
                  </li>
                  <li>
                    <a
                      href=""
                      onClick={handleLogout}
                      className="red_clr"
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Navbar>
    </>
  );
}

export default Header;
